var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferencePanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C3 3.44772 3.44772 3 4 3H18C18.5523 3 19 3.44772 19 4V8.74286C19 9.29514 18.5523 9.74286 18 9.74286C17.4477 9.74286 17 9.29514 17 8.74286V5H12V17C12 17.5523 11.5523 18 11 18H4C3.44772 18 3 17.5523 3 17V4ZM10 5H5V16H10V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19C20.2091 19 22 17.2091 22 15C22 12.7909 20.2091 11 18 11C15.7909 11 14 12.7909 14 15C14 15.8491 14.2646 16.6364 14.7158 17.284L11.7068 20.2929C11.3163 20.6834 11.3163 21.3166 11.7068 21.7071C12.0973 22.0976 12.7305 22.0976 13.121 21.7071L16.2368 18.5914C16.7687 18.8531 17.3672 19 18 19ZM18 17C19.1046 17 20 16.1046 20 15C20 13.8954 19.1046 13 18 13C16.8954 13 16 13.8954 16 15C16 16.1046 16.8954 17 18 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferencePanel);
export default __webpack_public_path__ + "static/media/ReferencePanel.b01a87963612ebe95358b92680f0b3ef.svg";
export { ForwardRef as ReactComponent };